import React, { forwardRef } from "react";
import CodingChallenge from "./CodingChallenge";
import { normalizeSampleCode } from "../../utils/judgeLanguages";

const Sandbox = forwardRef(({ sampleCode, question, testCases, description, onSubmit, disabled }, ref) => {
  // Convert sampleCode keys from DB format ("JavaScript", "C++") to Monaco IDs ("javascript", "cpp")
  const normalizedSampleCode = normalizeSampleCode(sampleCode);

  const mostFrequentWordTestCases = (testCases || []).map(tc => ({
    input: tc.input,
    expected: tc.expectedOutput,
    isHidden: tc.isHidden || false,
  }));

  return (
    <CodingChallenge
      challengeId="most-frequent-word"
      question={question}
      sampleCode={normalizedSampleCode}
      testCases={mostFrequentWordTestCases}
      description={description}
      onSubmit={onSubmit}
      disabled={disabled}
      ref={ref}
    />
  );
});

export default Sandbox;
